import qs from "query-string";
import { Platform, CommonRuntime } from "utils/runtime";

export enum CTR_ACTION {
	show = "show",
	click = "click",
}
const ctrTrackUrl = "https://ctrlitb.rightinthebox.com/ctr_tracking.php";
/*
action ( show or click)
area（recommend_goods）
client (m:jupiter , pc:vela, app: ios or android)
post (从1开始编号，以英文逗号分隔)
pids (商品id, 从1开始编号，以英文逗号分隔， action为show时使用)
cpid (点击的商品id, action 为click时使用)
mp (tights)
*/

const getClient = (runtime: CommonRuntime) => {
	const { client } = runtime;
	if (client === Platform.MWEB) {
		return "jupiter";
	} else if (client === Platform.WEB) {
		return "vela";
	}
	// APP client
	return client;
};
export interface SetLitbCtrTrackOnReq {
	mp?: string; // 页面
	action?: string; // 曝光或点击
	area?: string; // 区块
	entity?: string; // 区分独立区
	pos?: string; // 位置
	pid?: string; // 商品id
	pids?: string; // 商品组id
	cpid?: string; // click的商品id
	cids?: string; // 品类id组
	ccid?: string; // click的品类id
	cid?: string; // 品类id
	cids_adv?: string; // (分模块商品组集合的曝光)（url追加参数）
	ccids_adv?: string; // (分模块商品组集合的点击)（url追加参数）
}

export function getCookie(cname) {
	const name = cname + "=";
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1);
		if (c.indexOf(name) !== -1) return c.substring(name.length, c.length);
	}
	return "";
}

/**
 * 商品模块ctr 追踪使用https://www.tapd.cn/20404221/markdown_wikis/show/#1120404221001016487
 * @param props TrackLitbCtrReq
 * @param options
 * @returns
 */
export const SetLitbCtrTrackByType = (action: CTR_ACTION) => {
	let url = ctrTrackUrl;

	// 头部runtime和活动页runtime字段不一致，添加字段需要注意头部runtime
	return function LitbCtrTrack<T>(params: T, runtime: CommonRuntime) {
		params = {
			area: "recommend_goods",
			action,
			client: getClient(runtime),
			mp: "tights",
			language: runtime?.languageCode,
			country: runtime?.countryCode3,
			currency: runtime?.currency,
			__cust: getCookie("__cust"),
			...params,
		};
		// console.log("埋点上报传参数据", params);
		url = `${url}?${qs.stringify(params)}`;
		if (!runtime?.isUat) {
			fetch(url, { mode: "no-cors" }).catch((error) => {
				console.log("ctr error", error);
			});
		}
	};
};
export const SetLitbCtrTrackOnAction = async (
	params: SetLitbCtrTrackOnReq,
	runtime: CommonRuntime,
) => {
	SetLitbCtrTrackByType(CTR_ACTION.click)(params, runtime);
};
export const SetLitbCtrTrackOnShow = async (
	params: SetLitbCtrTrackOnReq,
	runtime: CommonRuntime,
) => {
	SetLitbCtrTrackByType(CTR_ACTION.show)(params, runtime);
};
